import React, { useEffect, useState, useRef } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import store, { useAppDispatch } from './app/store';
import { useAppSelector } from "./app/hooks";
import { useGetArticleItemsQuery, useGetFiltersQuery } from './data/api/api';
import { setArticles } from './data/slices/articles-slice';
import { ArticleList } from './components/article-listing';
import { ArticleFilters } from './components/article-filtering';
import ReactPaginate from 'react-paginate';
import { IArticleItem } from './interfaces/types';
import { useMediaQuery } from 'react-responsive';
import { useArticleFilters } from './hooks/use-article-filterss'
interface IArticleListingApp {
    id: string;
}
 
//create new function component called FilterApp that takes an id:string as a prop
const ArticleListingApp: React.FC<IArticleListingApp> = ({ id }) => {
    const appRef = useRef<HTMLDivElement>(null); // 👈 create a ref for the app container
    const pageId = (window as any).pageId;
    const { data: articlesData, error: articlesError, isLoading: articlesLoading } = useGetArticleItemsQuery(pageId);
    const articles: IArticleItem[] = useAppSelector((state) => state.articles.results);
    const filtersText = useAppSelector((state) => state.filterText);
    const dispatch = useAppDispatch();
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1024px)' });
    const itemsPerPage = filtersText.maxItemsPerPage; 
    //Applied Filters
    const {
        filteredArticles,
        pagedArticles,
        currentPage,
        pageCount,
        setCurrentPage,
        appliedFilterCategories,
        toggleCategory,
        resetFilters,
        updateSortOrder,
        appliedSortOrder
    } = useArticleFilters(articles, itemsPerPage);
    const [filterCategoriesExpanded, setFilterCategoriesExpanded] = useState(false);
    const [mobileFiltersExpanded, setMobileFiltersExpanded] = useState(false);
    //Pagination
    const currentArticles = pagedArticles;
    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
        if (appRef.current) {
            const navContainer = document.getElementById('navContainer');
            const navHeight = navContainer ? navContainer.offsetHeight : 0;
            const appTop = appRef.current.getBoundingClientRect().top + window.scrollY;
            // Scroll to app position minus nav height
            window.scrollTo({
                top: appTop - navHeight,
                behavior: 'smooth',
            });
        }
    };

    const handleCategoryChange = (label: string, event: React.ChangeEvent<HTMLInputElement>) => {
        toggleCategory(label, event.target.value); 
    };

    const handleSortOrderChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        updateSortOrder(event.target.value);
    };

    useEffect(() => {
        setCurrentPage(0);
    }, [filteredArticles]);

    useEffect(() => {
        if (articlesData) dispatch(setArticles(articlesData));
    }, [articlesData, dispatch]);
    return (
        <>
            <div className="article-listing" ref={appRef}>
                <div className="article-listing-inner">
                    {
                        isTabletOrMobile ? <> 
                            <button className="article-listing-filter-btn" aria-controls="mobileFilters" aria-expanded={mobileFiltersExpanded} onClick={() => {
                                setMobileFiltersExpanded(!mobileFiltersExpanded)
                            }}>
                                {filtersText.header}
                            </button>
                            <div id="mobileFilters" className="article-listing-filters-panel" aria-hidden={!mobileFiltersExpanded}>
                                <div className="article-listing-filters-panel-inner">
                                    <ArticleFilters
                                        filtersText={filtersText}
                                        appliedFilterCategories={appliedFilterCategories}
                                        filterCategoriesExpanded={filterCategoriesExpanded}
                                        currentArticlesCount={currentArticles.length}
                                        totalArticlesCount={filteredArticles.length}
                                        onResetFilters={resetFilters}
                                        onCategoryChange={handleCategoryChange}
                                        onToggleCategories={() =>
                                            setFilterCategoriesExpanded(!filterCategoriesExpanded)
                                        }
                                        onSortOrderChange={handleSortOrderChange}
                                        appliedSortOrder={appliedSortOrder}
                                        isTabletOrMobile={isTabletOrMobile}
                                        mobileFiltersExpanded={mobileFiltersExpanded}
                                    />
                                </div>
                            </div>
                        </> : <ArticleFilters
                            filtersText={filtersText}
                            appliedFilterCategories={appliedFilterCategories}
                            filterCategoriesExpanded={filterCategoriesExpanded}
                            currentArticlesCount={currentArticles.length}
                            totalArticlesCount={filteredArticles.length}
                            onResetFilters={resetFilters}
                            onCategoryChange={handleCategoryChange}
                            onToggleCategories={() =>
                                setFilterCategoriesExpanded(!filterCategoriesExpanded)
                            }
                            onSortOrderChange={handleSortOrderChange}
                            appliedSortOrder={appliedSortOrder}
                        />
                    }

                    <div className="stack-lg">
                        <ArticleList articles={currentArticles} isLoading={articlesLoading} hasError={articlesError} />
                        {
                            pageCount > 1 ?
                                <div className="article-listing-inner">
                                    <ReactPaginate
                                        className={"react-pagination"}
                                        breakLabel="..."
                                        nextLabel="next"
                                        onPageChange={handlePageClick}
                                        pageRangeDisplayed={5}
                                        pageCount={pageCount}
                                        previousLabel="previous"
                                        renderOnZeroPageCount={null}
                                        pageLinkclassName="article-listing-pagination-link"
                                        forcePage={currentPage} // <-- This keeps ReactPaginate in sync
                                    />
                                </div>
                                : null
                        }
                        {
                            filteredArticles.length === 0 || currentArticles.length === 0 ?
                                <div className="rich-text space-top" dangerouslySetInnerHTML={{ __html: filtersText.noResultsMessage }} /> : null
                        }
                    </div>
                </div>
            </div>
            
        </>
  );
};


export function ArticleListingAppInit(appRoot: HTMLElement) { 
    const root = ReactDOM.createRoot(
        appRoot
    );
    root.render(
        <React.StrictMode>
            <Provider store={store}>
                <ArticleListingApp id={appRoot.getAttribute('id').toString()} />
            </Provider>
        </React.StrictMode>
    );
}

const articleListingAppRoot = document.getElementById('articleListing') as HTMLElement;
ArticleListingAppInit(articleListingAppRoot)